export default "__VITE_ASSET__A9dEmqrA__"